/**
 * Returns whether a unit test is running
 * @returns Whether a unit test is running
 */
const isUnitTestRunning = () => {
  return process.env.JEST_WORKER_ID !== undefined;
};

export { isUnitTestRunning };
